import { render, staticRenderFns } from "./BranchRolesTable.vue?vue&type=template&id=23c59509&"
import script from "./BranchRolesTable.vue?vue&type=script&lang=js&"
export * from "./BranchRolesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports